import { createContext } from "react";
interface UserInformation {
  token: string;
  name: string;
  mobile: number;
  email: string;
  type: any;
  id: any;
}
interface AuthenticationInterface {
  userInfo: UserInformation;
  isLogged: boolean;
  login: (
    token: string,
    name: string,
    mobile: number,
    email: string,
    type: number,
    id: any
  ) => void;
  logout: () => void;
}

const AuthenticationContext = createContext<AuthenticationInterface>({
  userInfo: {
    token: "",
    name: "",
    mobile: 0,
    email: "",
    type: 0,
    id: null,
  },
  isLogged: false,
  login: () => {},
  logout: () => {},
});
export default AuthenticationContext;

export type {
  UserInformation
}